import "~/styles/globals.css";

import { AppProps } from "next/app";
import Head from "next/head";
import { trpc } from "~/trpc";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AzureAppInsights } from "~/monitoring/withAITracking";
import { useRouter } from "next/router";
import { useEffect } from "react";

function RetireHelpModelStorage() {
  useEffect(() => {
    // Remove only the model files and cache buckets created by LEAPS Help.
    // Browsers that never downloaded it have nothing to remove.
    void (async () => {
      if (typeof caches !== "undefined") {
        await Promise.allSettled([
          caches.delete("litert-model-e4b-v1"),
          caches.delete("litert-model-v1"),
        ]);
      }
      const root = await navigator.storage?.getDirectory?.().catch(() => null);
      await root?.removeEntry("leaps-help-gemma-4-E4B-it-web.litertlm").catch(() => undefined);
    })();
  }, []);
  return null;
}

function App(props: AppProps) {
  const { Component, pageProps } = props;

  const router = useRouter();
  const devtools = router.query.devtools;

  return (
    <>
      <Head>
        <title>LEAPS</title>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width, user-scalable=no"
        />
      </Head>

      {typeof devtools !== "undefined" && (
        <ReactQueryDevtools
          initialIsOpen={false}
          panelPosition={"right"}
          position={"bottom-right"}
        />
      )}

      <AzureAppInsights>
        <Component {...pageProps} />
      </AzureAppInsights>
      <RetireHelpModelStorage />
    </>
  );
}

export default trpc.withTRPC(App);
